import { Component, Input, OnInit } from "@angular/core"
import { LearningObject } from "../../../models/learningObject.model"
import { Resource } from "../../../models/resource/resource"
import { PreviewService } from "../../../services/preview.service"
import { Observable } from "rxjs"

@Component({
    selector: "app-related-resources",
    templateUrl: "./related-resources.component.html",
    styleUrls: ["./related-resources.component.scss"],
    standalone: false,
})
export class RelatedResourcesComponent implements OnInit {
    relatedResources: LearningObject[] = []
    gtmPrefix: string = "ymal"
    @Input() resource: Resource

    isInPreviewMode$: Observable<boolean>

    constructor(private previewService: PreviewService) {}

    ngOnInit() {
        this.isInPreviewMode$ = this.previewService.previewOnResource$
        this.relatedResources = this.resource.relatedResources
    }
}
